/* eslint-disable*/
import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
  // scriptUrl: '//at.alicdn.com/t/font_2230798_6zo3pw90h19.js'
  scriptUrl: '//at.alicdn.com/t/font_2231229_ivth4vnonlq.js'
});

export default IconFont;